// Lightweight analytics: Google Ads gtag (base tag inline in index.html) + dynamic Meta Pixel /
// extra Google tag configured by admins, plus UTM capture for ad attribution.

const GOOGLE_ADS_ID = "AW-18229787172";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "ref", "gclid", "fbclid"];

function _gtag(...args) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag(...args);
  } catch {
    /* analytics must never break the user flow */
  }
}

function _fbq(...args) {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  try {
    window.fbq(...args);
  } catch {
    /* ignore */
  }
}

/** Capture ad params from the URL into localStorage (survives the OTP step). */
export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v.slice(0, 200);
    });
    if (Object.keys(found).length) {
      found._landing = window.location.pathname;
      found._at = new Date().toISOString();
      localStorage.setItem("crece_utm", JSON.stringify(found));
      if (found.utm_source) {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/track-view`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            utm_source: found.utm_source,
            utm_medium: found.utm_medium || "",
            utm_campaign: found.utm_campaign || "",
            path: found._landing,
          }),
          keepalive: true,
        }).catch(() => {});
      }
    }
  } catch {
    /* ignore */
  }
}

export function getUtm() {
  try {
    return JSON.parse(localStorage.getItem("crece_utm") || "null");
  } catch {
    return null;
  }
}

/** Load admin-configured Meta Pixel + extra Google tag (IDs live in the database). */
export async function initTracking() {
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/tracking-config`);
    const cfg = await res.json();
    if (cfg.meta_pixel_id && !window.fbq) {
      /* eslint-disable */
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
        t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      /* eslint-enable */
      window.fbq("init", cfg.meta_pixel_id);
      window.fbq("track", "PageView");
    }
    if (cfg.google_tag_id && cfg.google_tag_id !== GOOGLE_ADS_ID) {
      _gtag("config", cfg.google_tag_id);
    }
  } catch {
    /* ignore */
  }
}

/** Fired exactly once after a successful partner registration. */
export function trackSignupConversion(value = 1.0) {
  _gtag("event", "conversion", {
    send_to: `${GOOGLE_ADS_ID}/fxTqCOW9zrwcEKT00fRD`,
    value: value,
    currency: "INR",
  });
  _gtag("event", "sign_up", { method: "email_otp" });
  _fbq("track", "CompleteRegistration", { currency: "INR", value });
}
